import React from 'react';
import { Button, Typography, Box, Paper } from '@mui/material';
import CallIcon from '@mui/icons-material/Call';
import CallEndIcon from '@mui/icons-material/CallEnd';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

const SipCallComponent = ({ ramal, status, isCalling, onCall, onHangup }) => {

    const getStatusLabel = () => {
        switch (status) {
            case 'Registered': return 'Registrado';
            case 'Connected': return 'Conectado';
            case 'Disconnected': return 'Desconectado';
            case 'Connecting...': return 'Conectando...';
            default: return status || 'Aguardando';
        }
    };

    const getStatusColor = () => {
        switch (status) {
            case 'Registered': return 'green';
            case 'Connected': return '#48D1CC';
            case 'Disconnected': return 'red';
            case 'Connecting...': return 'orange';
            default: return 'orange';
        }
    };

    return (
        <Paper elevation={3} sx={{ p: 2, borderRadius: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1, minWidth: '200px' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <FiberManualRecordIcon sx={{ color: getStatusColor(), fontSize: 12 }} />
                <Typography variant="caption" sx={{ fontWeight: 'bold' }}>{getStatusLabel()}</Typography>
            </Box>

            {!isCalling ? (
                <Button
                    variant="contained"
                    color="success"
                    startIcon={<CallIcon />}
                    onClick={() => onCall(ramal)}
                    disabled={status !== 'Registered'}
                    sx={{ borderRadius: 20, textTransform: 'none' }}
                >
                    Chamar Nativo ({ramal})
                </Button>
            ) : (
                <Button
                    variant="contained"
                    color="error"
                    startIcon={<CallEndIcon />}
                    onClick={onHangup}
                    sx={{ borderRadius: 20, textTransform: 'none' }}
                >
                    Desligar
                </Button>
            )}
        </Paper>
    );
};

export default SipCallComponent;
